// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { cityCodes } from 'helpers/countryHelpers';

// Material Dashboard 2 PRO React context - MUI 7 uyumluluğu için kaldırıldı
// import { useMaterialUIController } from 'context';
import { formatPhoneNumber } from 'helpers/smallCodes';

// WhatsApp mesaj linkini oluşturan fonksiyon
const createWhatsAppLink = (phone, firstName, lastName) => {
    const formattedPhone = formatPhoneNumber(phone).replace('+', '');
    const message = encodeURIComponent(`Merhaba ${firstName} ${lastName}, size ahsaplar.com üzerinden ulaşmaktayız.`);
    return `https://wa.me/${formattedPhone}?text=${message}`;
};

function BillingInformation({ billing }) {
    // MUI 7 uyumluluğu için context kullanımı kaldırıldı
    // const [controller] = useMaterialUIController();
    // const { darkMode } = controller;

    return (
        <MDBox>
            <MDTypography
                variant="h6"
                fontWeight="medium"
                sx={{
                    color: '#374151',
                    marginBottom: '16px',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <MDBox
                    sx={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#10B981',
                        borderRadius: '4px',
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <MDTypography sx={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>💳</MDTypography>
                </MDBox>
                Fatura Bilgileri
            </MDTypography>
            <MDBox
                sx={{
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    border: '1px solid #e2e8f0',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <MDBox width="100%" display="flex" flexDirection="column" lineHeight={1}>
                    <MDBox mb={3}>
                        <MDTypography
                            variant="h6"
                            fontWeight="bold"
                            sx={{
                                color: '#1f2937',
                                fontSize: '1.1rem',
                            }}
                        >
                            {billing?.first_name} {billing?.last_name}
                        </MDTypography>
                    </MDBox>

                    {[
                        { label: '🏢 Firma', value: billing?.company || '-' },
                        {
                            label: '📍 Adres',
                            value: `${billing?.address_1}${billing?.address_2 ? `, ${billing.address_2}` : ''}`,
                        },
                        {
                            label: '🌍 İl/İlçe',
                            value: `${billing?.city}, ${cityCodes[billing?.state]} ${billing?.postcode}`,
                        },
                        { label: '📧 E-posta', value: billing?.email },
                    ].map((item, index) => (
                        <MDBox key={index} mb={2}>
                            <MDBox
                                sx={{
                                    backgroundColor: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: '600',
                                        minWidth: '80px',
                                        fontSize: '0.75rem',
                                    }}
                                >
                                    {item.label}:
                                </MDTypography>
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#374151',
                                        fontWeight: '500',
                                        marginLeft: '8px',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {item.value}
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    ))}

                    <MDBox>
                        <MDBox
                            sx={{
                                backgroundColor: '#f0fdf4',
                                border: '1px solid #bbf7d0',
                                borderRadius: '8px',
                                padding: '12px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <MDTypography
                                variant="caption"
                                sx={{
                                    color: '#6b7280',
                                    fontWeight: '600',
                                    minWidth: '80px',
                                    fontSize: '0.75rem',
                                }}
                            >
                                📱 Telefon:
                            </MDTypography>
                            <MDTypography
                                variant="caption"
                                fontWeight="medium"
                                component="a"
                                href={createWhatsAppLink(billing?.phone, billing?.first_name, billing?.last_name)}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    marginLeft: '8px',
                                    cursor: 'pointer',
                                    color: '#10B981',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    fontSize: '0.8rem',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                        color: '#059669',
                                    },
                                }}
                            >
                                {formatPhoneNumber(billing?.phone)}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </MDBox>
        </MDBox>
    );
}

export default BillingInformation;
